<div [ngClass]="type()" class="hint">
  <div class="hint-info-wrapper">
    @if (icon()) {
      <accredible-icon [icon]="icon()" />
    }

    @if (image()) {
      <img [src]="image()" alt="" />
    }

    @if (content()) {
      <span [innerHTML]="content()" class="font-multiline-normal-regular"></span>
    }
    <ng-content select="[hintContent]" />
  </div>

  <ng-content select="[hintAction]" />
</div>
